import {
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog as MuiDialog,
} from "@mui/material";
import { cloneElement, createContext, useContext, useState } from "react";
import { MdClose } from "react-icons/md";

const DialogContext = createContext();

function Title({ children }) {
  const { handleClose } = useContext(DialogContext);

  return (
    <DialogTitle
      variant="h5"
      textAlign="center"
      mt={children && 2}
      style={{ padding: 12 }}
      fontWeight={500}
    >
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <MdClose />
      </IconButton>
      {children}
    </DialogTitle>
  );
}

function Open({ children }) {
  const { handleClickOpen } = useContext(DialogContext);
  return cloneElement(children, {
    onClick: handleClickOpen,
  });
}

function Dialog({
  children,
  title,
  maxWidth = "xs",
  openElement: openDialogElement,
}) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DialogContext.Provider value={{ open, handleClickOpen, handleClose }}>
      <Open>{openDialogElement}</Open>
      <MuiDialog
        fullWidth
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
      >
        <Title>{title}</Title>
        <DialogContent sx={{ mt: 1 }}>
          {cloneElement(children, { handleClose })}
        </DialogContent>
      </MuiDialog>
    </DialogContext.Provider>
  );
}

export default Dialog;
